<div class="vehicle-wrapper">
    <div class="top-header">
      <h3>Add BlackList Vehicle</h3>
      <p>Please fill in all required fields</p>
    </div>
    <form [formGroup]="blackListForm" (ngSubmit)="onSubmit()">
      <div class="form-row">
        <div class="form-item">
          <label for="vehicleNumber">Vehicle Number <small>*</small></label>
          <input type='text' formControlName="vehicleNumber" id="vehicleNumber">
          <div  class="error" *ngIf="blackListForm.get('vehicleNumber')?.invalid && blackListForm.get('vehicleNumber')?.touched">
            <small *ngIf="blackListForm.get('vehicleNumber')?.errors?.['required']">Vehicle Number is required.</small>
          </div>
        </div>
          <div class="form-item">
              <label for="personName">Person Name</label>
              <input type="text" formControlName="personName" id="personName" placeholder="Optional">
          </div>
        <div class="form-item">
          <label for="reason">Reason (Max 300 Characters) <small>*</small></label>
           <textarea formControlName="reason" id="reason"></textarea>
          <div  class="error" *ngIf="blackListForm.get('reason')?.invalid && blackListForm.get('reason')?.touched">
            <small *ngIf="blackListForm.get('reason')?.errors?.['required']">Reason is required</small>
            <small *ngIf="blackListForm.get('reason')?.errors?.['maxlength']">Maximum 300 characters allowed</small>
          </div>
        </div>
      </div>
      <div class="button-row">
        <button type="submit" class="btn-save">
          <fa-icon [icon]="['fas', 'square-plus']" class="fa-solid"></fa-icon> BLACKLIST
        </button>
        <button type="button" class="btn-cancel" (click)="onCancel()" >
          <fa-icon [icon]="['fas', 'square-xmark']" class="fa-thin"></fa-icon> CANCEL
        </button>
      </div>
    </form>
  </div>